/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Priorities/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Priority from './Priority/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Priorities({
  children,
  viewPath = "/DesignSystem/TasksFilters/Priority/Content/Priorities"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Priority'
let prioritiesValueData = fromData.useDataValue({ viewPath,
context: 'priorities',
})
  return (<React.Fragment
>
<div
  data-testid="Priorities.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(prioritiesValueData) && prioritiesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="priority"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Priority(${item?.id ?? item?._id ?? index})`}
      >
<fromFlow.When is={flowValue === 'Priority'}>
<Priority
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Priority(${item?.id ?? item?._id ?? index})`}
/>
</fromFlow.When>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }